import { IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { trackAnswerQuestionsClick } from './tracking';
import { openChatbotFiltersModal } from '../../actions/chatbotFiltersModal';
import { ChatbotButton } from '../../components/ChatbotButton';

export const AnswerQuestionsButtonContainer: React.FC = () => {
  const dispatch = useDispatch();

  const onClick = React.useCallback(() => {
    trackAnswerQuestionsClick();
    dispatch(openChatbotFiltersModal());
  }, [dispatch]);

  return (
    <ChatbotButton
      onClick={onClick}
      theme="fill_white_primary"
      afterIcon={<IconActionArrowRight16 color="icon-main-default" />}
    >
      Ответить на&#x00a0;вопросы
    </ChatbotButton>
  );
};
